import queryString from "query-string";
import type { SearchPatientsElasticQueryVariables } from "./_lib/__generated__/queries.gql";

export function linkToPatientSearch() {
  return "/patient-search";
}

export type PatientSearchResultsQueryParams = {
  patient: SearchPatientsElasticQueryVariables["patient"];
  offset?: number;
  limit?: number;
  offline?: boolean;
  searchWholeTerritory?: boolean;
};

export function linkToPatientSearchResults(
  opts?: PatientSearchResultsQueryParams,
) {
  let queryParams: string | undefined;

  if (opts) {
    queryParams = queryString.stringify({
      ...opts,
      patient: JSON.stringify(opts.patient),
    });
  }

  return `${linkToPatientSearch()}/results${
    queryParams ? `?${queryParams}` : ""
  }`;
}

export function parsePatientSearchResultsQueryParams(
  search: string,
): PatientSearchResultsQueryParams {
  const parsed = queryString.parse(search);
  return {
    patient: JSON.parse(parsed.patient as string),
    offline: parsed.offline === "true",
    searchWholeTerritory: parsed.searchWholeTerritory === "true",
    limit: parsed.limit ? parseInt(parsed.limit as string) : undefined,
    offset: parsed.offset ? parseInt(parsed.offset as string) : undefined,
  };
}
